import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`

*{
boz-sizing: border-box;
}

body{
font-family: 'Plus Jakarta Sans', sans-serif;
}

img{
max-width: 100%;
}
`;

export default GlobalStyles;
